import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import moment from 'moment';

const contextPath = '/admin/asset'

export const useGetItemSel = (param) => {

    const sendParam = {
        cid: param && param.cid && param.cid > 0 ? param.cid : 0,
        status: param && param.status && param.status !== '' ? param.status : '',
        // sdate: param && param.sdate && param.sdate !== '' ? param.sdate : moment().subtract(1,'year').format('yyyyMMDD'),
        sdate: param && param.sdate && param.sdate !== '' ? param.sdate : '',
        edate: param && param.edate && param.edate !== '' ? param.edate : moment().format('yyyyMMDD'),
        is_use: 1,//param && param.is_use !== 1 ? param.is_use : true,
        has_sub: param && param.has_sub && param.has_sub !== '' ? param.has_sub : undefined,
        is_sub: param && param.is_sub && param.is_sub !== '' ? param.is_sub : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }

    return useQuery('ASSET_ITEM_SEL', () => getItemsSel(sendParam));

}

const getItemsSel = async (param) => {
    const retVal = await instance.get(contextPath+'/items', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}

export const useSetItem = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postItem(sendParam);
                case 'PUT':
                    return putItem(sendParam);
                case 'DELETE':
                    return deleteItem(sendParam);
                default :
                    return putItem(sendParam);
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_ITEM_SEL', { refetchInactive: true })
            },
        }
    )
}

const postItem = async (param) => {

    const sendParam = {
        cid: param.cid,
        lot_no: param.lot_no,
        status: param.status,
        maf_id: param.maf_id,
        model_nm: param.model_nm, 
        model_sub: param.model_sub,
        serial_no: param.serial_no,
        maf_date: param.maf_date,
        pur_date: param.pur_date,
        pur_tp: param.pur_tp,
        pur_price: param.pur_price,
        spec: param.spec,
        location: param.location,
        uid1:param.uid1,
        uid2:param.uid2,
        descr1:param.descr1,
        descr2:param.descr2
    }

    const retVal = await instance.post(contextPath+'/items', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;
}

const putItem = async (param) => {

    const sendParam = {
        tid: param.tid,
        cid: param.cid,
        lot_no: param.lot_no,
        status: param.status,
        maf_id: param.maf_id,
        model_nm: param.model_nm, 
        model_sub: param.model_sub,
        serial_no: param.serial_no,
        maf_date: (param.maf_date && param.maf_date !== '') ? moment(param.maf_date).format('YYYYMMDD') : undefined,
        pur_date: (param.pur_date && param.pur_date !== '') ? moment(param.pur_date).format('YYYYMMDD') : undefined,
        pur_tp: param.pur_tp,
        pur_price: param.pur_price,
        spec: param.spec,
        location: param.location,
        uid1:param.uid1,
        uid2:param.uid2,
        descr1:param.descr1,
        descr2:param.descr2
    }

    const retVal = await instance.put(contextPath+'/items', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;
}

const deleteItem = async (param) => {

    const sendParam = {
        tid: param.tid,
    }

    const retVal = await instance.put(contextPath+'/delItems', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;
}

export const useGetItemHistSel = (param) => {
    const sendParam = {
        tid: param && param.tid && param.tid > 0 ? param.tid : undefined,
        cid: param && param.cid && param.cid !== '' ? param.cid : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_ITEM_HIST_SEL', () => getItemsHistSel(sendParam));
}
const getItemsHistSel = async (param) => {
    const retVal = await instance.get(contextPath+'/itemsHist', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}


export const useGetItemByTno = (param) => {
    return useQuery('M_ITEM_INFO', () => getItemsByTno(param));
}
const getItemsByTno = async (param) => {

    if(param && param.tid){
        const retVal = await instance.get(contextPath+'/tnoItems', {params:param})
                                        .then((res)=>{
                                            return res.data[0];
                                        })
        return retVal;
    }
}

export const useSetItemRel = () => {
    const queryClient = useQueryClient();
    return useMutation(
        (sendParam) => setItemRel(sendParam),
        {
            onSuccess:()=>{
                queryClient.invalidateQueries('ASSET_ITEM_SEL', { refetchInactive: true })
            },
        }
    )
}

const setItemRel = async (param) => {

    const sendParam = {
        tid: param.tid,
        rid: param.rid,
        mod_st: param.mod_st,
    }

    const retVal = await instance.post(contextPath+'/itemRel', sendParam)
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;
}

export const useGetStaticItemSum = (param) => {
    const sendParam = {
        cid: param && param.cid && param.cid !== '' ? param.cid : undefined,
        // tid: param && param.tid && param.tid > 0 ? param.tid : undefined,
        // row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        // row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_STATIC_ITEM_SUM', () => getStaticItemSum(sendParam));
}
const getStaticItemSum = async (param) => {
    const retVal = await instance.get(contextPath+'/staticItemSum', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}

export const useGetItemLog = (param) => {
    const sendParam = {
        tid: param && param.tid && param.tid > 0 ? param.tid : undefined,
        mod_tp: param && param.mod_tp && param.mod_tp !== '' ? param.mod_tp : undefined,
        row_no: param && param.row_no && param.row_no !== 10 ? param.row_no : 0, 
        row_cnt: param && param.row_cnt && param.row_cnt > 0 ? param.row_cnt : 10000,
    }
    return useQuery('ASSET_ITEM_LOG', () => getItemLogSel(sendParam));
}
const getItemLogSel = async (param) => {
    const retVal = await instance.get(contextPath+'/getItemLogSel', {params:param})
                                    .then((res)=>{
                                        return res.data[0];
                                    })
    return retVal;
}